import { FunctionComponent, ReactElement } from 'react';
import styled from 'styled-components';
import { BaseIcon } from '../../../components/DesignSystem';
import { Caption, FormText, Title6 } from '../../../styles/TypoStyle';

const Title = styled(Title6)`
  text-align: center;
  margin: 8px 0px 24px 0px;
  //mobile
  @media (max-width: 496px) {
    font-size: var(--typo-title6-mobile-font-size);
    line-height: var(--typo-title6-mobile-line-height));
    white-space: pre-line;
    margin: 8px 0px 16px 0px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin: 24px 0px 0px 0px;
  --card-padding: 16px;
  //mobile
  @media (max-width: 496px) {
    --card-padding: 8px;
    flex-direction: column;
  }
`;

const Card = styled.div`
  background-color: var(--colors-teal-light);
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-radius: 4px;
  width: 33.33%;
  @media (max-width: 496px) {
    width: 100%;
  }
`;

const CardTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin: 16px;
`;

const CardTitle = styled(FormText)`
  font-weight: bold;
  color: var(--colors-teal-dark);
  margin-top: 8px;
    font-size: 14px;
    //mobile
  @media (max-width: 496px) {
    font-size: var(--typo-form3-font-size);
    line-height: var(--typo-form3-line-height));
  }
`;

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 4px 24px 24px 56px;
  //mobile
  @media (max-width: 496px) {
    margin: 8px 24px 10px 16px;
  }
`;

const Header = styled(Caption)``;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 4px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-bottom: 8px;
`;

const Footer = styled(Caption)`
  margin-bottom: 24px;
  white-space: pre-line;
`;

const Cardtips = styled.div`
  display: flex;
  flex-direction: row;
  //tablet + desktop
  @media (min-width: 496px) {
    margin: 8px 0px 0px 0px;
  }
  //mobile
  @media (max-width: 496px) {
    span {
      white-space: pre-line;
    }
  }
  background-color: var(--blue-50);
  gap: 8px;
  img {
    margin: 18px 0px 0px 18px;
  }
  span {
    margin: 16px 16px 16px 0px;
  }
`;

const DataCardForPaper: FunctionComponent<Record<string, never>> = (): ReactElement => {
  return (
    <>
      <Title>{`Les prochaines étapes`}</Title>
      <Container>
        {/* <BaseCard> */}
        <Card>
          <CardTitleContainer>
            {/* <img src={walletIcon} width={40} height={40}></img> */}
            <BaseIcon icon="headphone" big="true" />
            <CardTitle>1. Rappel de votre conseiller</CardTitle>
          </CardTitleContainer>
          <CardBody>
            <Header>
              Un conseiller va vous rappeler pour finaliser ensemble votre demande. En cas d’avis favorable communiqué
              par le conseiller, votre offre de crédit vous sera envoyée.
            </Header>
          </CardBody>
        </Card>
        <Card>
          <CardTitleContainer>
            {/* <img src={send} width={40} height={40}></img> */}
            <BaseIcon icon="folder-open" big="true" />
            <CardTitle>2. Constitution du dossier</CardTitle>
          </CardTitleContainer>
          <CardBody>
            <Header>
              A réception de votre contrat, prenez-en connaissance et renvoyer l’exemplaire signé accompagné des pièces
              justificatives demandées.
            </Header>
          </CardBody>
        </Card>
        <Card>
          <CardTitleContainer>
            {/* <img src={send} width={40} height={40}></img> */}
            <BaseIcon icon="check-square" big="true" />
            <CardTitle>3. Acceptation définitive</CardTitle>
          </CardTitleContainer>
          <CardBody>
            <Header>
              Après acceptation définitive de votre demande, nous nous chargeons de rembourser vos crédits antérieurs
              auprès des établissements concernés (après expiration du délai légal).
            </Header>
          </CardBody>
        </Card>
        {/* </BaseCard> */}
      </Container>
    </>
  );
};
export default DataCardForPaper;
